import React from "react";
import SectionFounder from "../SectionFounder";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Layout from "../../(others)/layout"
import "../../../styles/styles.css"

const PageAbout = () => {
  return (
    <Layout>
        <div className="dark bg-neutral-900/95 text-white  py-4 lg:py-7 space-y-4 lg:space-y-7">
            <div className="relative">
                <div className="fondateur">
                    <SectionFounder />
                </div>
            </div>
        </div>
    </Layout>
  );
};

export default PageAbout;
